import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";

import { selectHomeData, selectHomeStatus, selectHomeError, initializeAsync, getProposalsAsync } from "./homeSlice";

import { Button, Box, Paper, Menu, MenuItem, Typography, IconButton, Tooltip } from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import { config, styles } from "../../style";
import { useNavigate } from "react-router-dom";

import { EventCard } from "../../components/EventCard";
import { skeletonCard, skeletonCardUI, skeletonTable, skeletonTableUI } from "./skeleton";
import CustomiseTable from "../../components/CustomiseTable";
import { formateDate } from "../../utils/date";
import PersonIcon from "@mui/icons-material/Person";

import CardViewIcon from "../../icons/CardViewIcon";
import TableViewIcon from "../../icons/TableViewIcon";
import PollIcon from "../../icons/PollIcon";
import { useLocalStorage } from "../../hooks/useLocalStorage";

const columnsData = [
    {
        fieldName: "eventName",
        name: "Proposal",
        hideCellValue: true,
        renderElement: (row, currentCellValue) => {
            return (
                <Typography component={"span"} color={"#101828"} fontSize={"14px"} lineHeight={"20px"} fontWeight={600}>
                    {currentCellValue}
                </Typography>
            );
        },
    },
    {
        fieldName: "status",
        name: "Stage",
        hideCellValue: true,
        renderElement: (row, currentCellValue) => {
            return (
                <>
                    {currentCellValue && (
                        <Typography
                            component={"div"}
                            borderRadius={currentCellValue === "New" ? "16px" : "6px"}
                            bgcolor={currentCellValue === "New" ? "#FFF2E5" : "#F2F4F7"}
                            color={currentCellValue === "New" ? "#D0591D" : "#344054"}
                            padding={"4px 8px"}
                            fontSize={"12px"}
                            fontWeight={500}
                            lineHeight={"18px"}
                            width={"fit-content"}
                            marginRight={"1rem"}>
                            {currentCellValue}
                        </Typography>
                    )}
                </>
            );
        },
    },
    {
        fieldName: "lastUpdatedDate",
        name: "Last Updated",
        hideCellValue: true,
        renderElement: (row, currentCellValue) => {
            return <>{formateDate(currentCellValue)}</>;
        },
    },
    {
        fieldName: "ownerName",
        name: "Proposal Owner",
        hideCellValue: true,
        renderElement: (row, currentCellValue) => {
            return (
                <>
                    {currentCellValue && (
                        <Box
                            sx={{
                                display: "inline-flex",
                                verticalAlign: "text-bottom",
                                boxSizing: "inherit",
                                textAlign: "left",
                                alignItems: "flex-start",
                                fontSize: "12px",
                            }}>
                            <PersonIcon fontSize="medium" sx={{ color: "gray", width: "20px" }} />
                            <Typography
                                variant="body"
                                fontSize={"14px"}
                                fontWeight={400}
                                color={"#101828"}
                                lineHeight={"20px"}
                                sx={{ marginLeft: "5px" }}>
                                {currentCellValue}
                            </Typography>
                        </Box>
                    )}
                </>
            );
        },
    },
    {
        fieldName: "poll",
        name: "Poll",
        hideCellValue: true,
        renderElement: (row, currentCellValue) => {
            return (
                <>
                    <Typography
                        component={"div"}
                        borderRadius="16px"
                        bgcolor={currentCellValue === "Active" ? "#ECFDF3" : "#F2F4F7"}
                        color={currentCellValue === "Active" ? "#027A48" : "#344054"}
                        padding={"4px 8px"}
                        fontSize={"12px"}
                        fontWeight={500}
                        lineHeight={"18px"}
                        width={"fit-content"}
                        display={"flex"}
                        alignItems={"center"}>
                        {/* <Box
                            component={"div"}
                            sx={{ width: "8px", height: "8px", borderRadius: "50%", background: currentCellValue === "Active" ? "#12B76A" : "#667085" }}
                            marginRight={"0.5rem"}
                        ></Box> */}
                        <PollIcon
                            style={{
                                color: currentCellValue === "Active" ? "#12B76A" : "#667085",
                            }}
                        />
                        {currentCellValue === "Active" ? "Active" : "Inactive"}
                    </Typography>
                </>
            );
        },
    },
    {
        fieldName: "shared",
        name: "Proposal Shared",
        renderElement: (row, currentCellValue) => {
            return <span>{currentCellValue ? "Yes" : "No"}</span>;
        },
    },
];
const Home = () => {
    const data = useSelector(selectHomeData);
    const status = useSelector(selectHomeStatus);
    const error = useSelector(selectHomeError);
    const dispatch = useDispatch();
    const { getUserDetails, getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const filterOpen = Boolean(anchorEl);

    const [anchorSortEl, setAnchorSortEl] = React.useState(null);
    const [view, setView] = useLocalStorage("proposalView", "cards");
    const sortOpen = Boolean(anchorSortEl);

    const filter = data.type ? (data.type === "Open" ? "Active" : data.type === "Closed" ? "Archived" : data?.type) : "Active";
    const [proposalFilter, setProposalFilter] = useState(filter); //changed  Open => Active
    const [proposalSubFilter, setProposalSubFilter] = useState("");
    const [proposalSortBy, setProposalSortBy] = useState("Newest proposals");

    const toggleView = (view) => {
        setView(view);
    };

    const handleFilterMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleFilterMenuClose = (filterValue) => {
        if (!filterValue) {
            setAnchorEl(null);
            return;
        }
        // text changes => open=>Active and close=>Archived
        const filterValueText = filterValue === "Open" ? "Active" : filterValue === "Closed" ? "Archived" : filterValue;
        setProposalFilter(filterValueText);
        setProposalSubFilter("");
        setAnchorEl(null);
        dispatch(getProposalsAsync({ getUserDetails, type: filterValue }));
    };

    const handleSubActiveFilterMenuClose = (filterValue) => {
        if (proposalFilter !== "Active") {
            setProposalFilter("Active");
            dispatch(getProposalsAsync({ getUserDetails, type: "Open" }));
        }
        setProposalSubFilter(filterValue);
        setAnchorEl(null);
    };

    const handleSubInActiveFilterMenuClose = (filterValue) => {
        if (proposalFilter !== "Archived") {
            setProposalFilter("Archived");
            dispatch(getProposalsAsync({ getUserDetails, type: "Closed" }));
        }
        setProposalSubFilter(filterValue);
        setAnchorEl(null);
    };

    useEffect(() => {
        // data will load on first time page render
        if (status === "idle") {
            dispatch(initializeAsync({ getUserDetails, type: "Open" }));
        }
    }, [status, dispatch, getUserDetails]);

    // useEffect(() => {
    //     // data will load when switched to my-proposals router from other routes (menu item 'Active' selected by default)
    //     if (status !== "idle") {
    //         const filterValue =
    //             proposalFilter === "Active" ? "Open" : proposalFilter === "Archived" ? "Closed" : proposalFilter;
    //         dispatch(getProposalsAsync({ getUserDetails, type: filterValue }));
    //     }
    // }, []);

    const handleCardClick = (recordId) => {
        navigate("/proposal/" + recordId);
    };

    const handleSortMenuClose = (sortBy) => {
        if (!sortBy) {
            setAnchorSortEl(null);
            return;
        }
        setProposalSortBy(sortBy);
        setAnchorSortEl(null);
    };

    const handleSortMenuClick = (event) => {
        setAnchorSortEl(event.currentTarget);
    };

    const getSharedMessageText = (first, totalLength) => {
        if (totalLength === 0) {
            return `This has been shared with ${first}.`;
        }
        if (totalLength === 1) {
            return `This has been shared with ${first} and one other person.`;
        }

        return `This has been shared with ${first} and ${totalLength} other people.`;
    };

    const getSharedMessage = (record) => {
        let opportunityContactRoles = record.opportunityContactRoles?.filter((role) => role.Contact.Id !== userDetails.contact.id);
        let opportunityContactRolesShared = [
            ...(opportunityContactRoles?.map((item) => {
                return {
                    id: item.id,
                    contactId: item.Contact?.Id,
                    name: item.Contact?.FirstName + " " + item.Contact?.LastName,
                    email: item.Contact?.Email,
                };
            }) || []),
            ...(record.proposalParticipants?.map((item) => {
                return {
                    id: item.id,
                    contactId: item.Contact__r?.Id,
                    name: item.Contact__r?.FirstName + " " + item.Contact__r?.LastName,
                    email: item.Email__c,
                };
            }) || []),
        ];
        if (opportunityContactRolesShared?.length > 0) {
            let withNames = opportunityContactRolesShared.find((role) => role.contactId);
            if (withNames) {
                return getSharedMessageText(withNames.name, opportunityContactRolesShared.length - 1);
            } else {
                let withEmail = opportunityContactRolesShared.find((role) => role.email);
                if (withEmail) {
                    return getSharedMessageText(withEmail.email, opportunityContactRolesShared.length - 1);
                }
            }
        }

        return "This has been shared with some people.";
    };

    const getRecords = () => {
        if (data?.records?.length > 0) {
            let recordsToSort = [...data?.records];

            // dummy text added, it shoulb be removed
            // start
            recordsToSort = recordsToSort.map((cRecord, index) => {
                return {
                    ...cRecord,
                    sharedText: cRecord.shared ? getSharedMessage(cRecord) : "",
                };
            });
            // end

            if (proposalSubFilter) {
                recordsToSort = recordsToSort.filter((record) => {
                    return record.status === proposalSubFilter;
                });
            }

            if (proposalSortBy === "Newest proposals") {
                return recordsToSort.sort((a, b) => (new Date(a.createdDate) > new Date(b.createdDate) ? -1 : new Date(b.createdDate) > new Date(a.createdDate) ? 1 : 0));
            } else if (proposalSortBy === "Event date") {
                return recordsToSort.sort((a, b) => (new Date(a.startPlayDate) > new Date(b.startPlayDate) ? 1 : new Date(b.startPlayDate) > new Date(a.startPlayDate) ? -1 : 0));
            } else if (proposalSortBy === "Last updated") {
                return recordsToSort.sort((a, b) => (new Date(a.lastUpdatedDate) > new Date(b.lastUpdatedDate) ? -1 : new Date(b.lastUpdatedDate) > new Date(a.lastUpdatedDate) ? 1 : 0));
            } else if (proposalSortBy === "Created date") {
                return recordsToSort.sort((a, b) => (new Date(a.createdDate) > new Date(b.createdDate) ? -1 : new Date(b.createdDate) > new Date(a.createdDate) ? 1 : 0));
            }
        }
        return [];
    };

    let body = (
        <>
            {status === "initalLoading" ? (
                view === "cards" ? (
                    skeletonCard
                ) : (
                    skeletonTable
                )
            ) : (
                <>
                    <Box>
                        <Paper sx={{ p: "20px", display: "flex", flexDirection: "column" }} elevation={3}>
                            <Box style={{ fontSize: "12px", color: "gray" }}>Proposals for</Box>
                            <Box style={{ textTransform: "uppercase", fontWeight: "800", fontSize: "21px" }}>{data?.userDetails?.contact?.accountName}</Box>
                        </Paper>
                    </Box>
                    <Box sx={{ marginTop: "1rem", mb: "20px", pointerEvents: status === "loading" ? "none" : "unset" }}>
                        <Paper sx={{ p: "20px" }} elevation={3}>
                            <Grid container justifyContent="space-between">
                                <Grid item>
                                    <Box
                                        sx={{
                                            mb: "20px",
                                            mr:"1rem",
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box>
                                            <Button
                                                id="filter-speakers"
                                                aria-controls={filterOpen ? "basic-menu" : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={filterOpen ? "true" : undefined}
                                                onClick={handleFilterMenuClick}
                                                startIcon={<FilterListIcon fontSize="small" sx={{ color: config.primaryColor }} />}
                                                sx={{ ...styles.outlinedButton }}
                                                variant="outlined"
                                            >
                                                {`Proposal Filter: ${proposalSubFilter ? proposalSubFilter : proposalFilter}`}
                                            </Button>
                                            <Menu
                                                id="basic-menu"
                                                anchorEl={anchorEl}
                                                open={filterOpen}
                                                onClose={() => handleFilterMenuClose("")}
                                                MenuListProps={{
                                                    "aria-labelledby": "filter-speakers",
                                                }}
                                            >
                                                <MenuItem onClick={() => handleFilterMenuClose("Open")} value="Open">
                                                    Active Proposals
                                                </MenuItem>
                                                <MenuItem sx={{ p: 0, py: 0.5, pl: 4 }} onClick={() => handleSubActiveFilterMenuClose("New")}>
                                                    New
                                                </MenuItem>
                                                <MenuItem sx={{ p: 0, py: 0.5, pl: 4 }} onClick={() => handleSubActiveFilterMenuClose("Shortlisting")}>
                                                    Shortlisting
                                                </MenuItem>
                                                <MenuItem sx={{ p: 0, py: 0.5, pl: 4 }} onClick={() => handleSubActiveFilterMenuClose("Availability Checks")}>
                                                    Availability Checks
                                                </MenuItem>
                                                <MenuItem sx={{ p: 0, py: 0.5, pl: 4 }} onClick={() => handleSubActiveFilterMenuClose("Request To Book")}>
                                                    Request to Book
                                                </MenuItem>
                                                <MenuItem onClick={() => handleFilterMenuClose("Closed")} value="Closed">
                                                    Archived Proposals
                                                </MenuItem>
                                                <MenuItem sx={{ p: 0, py: 0.5, pl: 4 }} onClick={() => handleSubInActiveFilterMenuClose("Booked")}>
                                                    Booked
                                                </MenuItem>
                                                <MenuItem sx={{ p: 0, py: 0.5, pl: 4 }} onClick={() => handleSubInActiveFilterMenuClose("Cancelled")}>
                                                    Cancelled
                                                </MenuItem>
                                            </Menu>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            flexWrap:'wrap'
                                        }}
                                    >
                                        <Box display="flex" justifyContent="flex-end" marginRight={"0.5rem"} mb={'20px'} overflow={"auto"} border={"1px solid #D0D5DD"} borderRadius={"10px"} padding={"2px"}>
                                            <Tooltip title="Card View">
                                                <IconButton
                                                    onClick={() => setView("cards")}
                                                    sx={{
                                                        width: 32,
                                                        height: 30,
                                                        backgroundColor: view === "cards" ? "#70707B" : "transparent",
                                                        color: view === "cards" ? "#fff" : "#000",
                                                        "&:hover": {
                                                            backgroundColor: view === "cards" ? "#70707B" : "transparent",
                                                        },
                                                        padding: 0,
                                                        borderRadius: "10px",
                                                    }}
                                                >
                                                    {/* <ViewModuleIcon fontSize="medium" /> */}
                                                    <CardViewIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Table View">
                                                <IconButton
                                                    onClick={() => setView("table")}
                                                    sx={{
                                                        width: 32,
                                                        height: 30,
                                                        backgroundColor: view === "table" ? "#70707B" : "transparent",
                                                        color: view === "table" ? "#fff" : "#000",

                                                        "&:hover": {
                                                            backgroundColor: view === "table" ? "#70707B" : "transparent",
                                                        },
                                                        padding: 0,
                                                        borderRadius: "10px",
                                                    }}
                                                >
                                                    {/* <TableIcon /> */}
                                                    <TableViewIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        <Box mb={'20px'}>
                                            <Button
                                                id="sort-speakers"
                                                aria-controls={sortOpen ? "basic-menu" : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={sortOpen ? "true" : undefined}
                                                onClick={handleSortMenuClick}
                                                startIcon={<SortIcon fontSize="small" sx={{ color: config.primaryColor }} />}
                                                sx={{ ...styles.outlinedButton }}
                                                variant="outlined"
                                            >
                                                {`Sort by: ${proposalSortBy}`}
                                            </Button>
                                            <Menu
                                                id="basic-menu"
                                                anchorEl={anchorSortEl}
                                                open={sortOpen}
                                                onClose={() => handleSortMenuClose("")}
                                                MenuListProps={{
                                                    "aria-labelledby": "sort-speakers",
                                                }}
                                            >
                                                <MenuItem onClick={() => handleSortMenuClose("Newest proposals")} value="Newest proposals">
                                                    Newest proposals
                                                </MenuItem>
                                                <MenuItem onClick={() => handleSortMenuClose("Last updated")} value="Last updated">
                                                    Last updated
                                                </MenuItem>
                                                <MenuItem onClick={() => handleSortMenuClose("Created date")} value="Created date">
                                                    Created date
                                                </MenuItem>
                                                <MenuItem onClick={() => handleSortMenuClose("Event date")} value="Event date">
                                                    Event date
                                                </MenuItem>
                                            </Menu>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>

                            {status === "loading" ? (
                                view === "cards" ? (
                                    skeletonCardUI
                                ) : (
                                    skeletonTableUI
                                )
                            ) : (
                                <>
                                    {view === "table" ? (
                                        <CustomiseTable
                                            columns={columnsData}
                                            rows={getRecords()}
                                            hoverEffect={false}
                                            componentStyleProps={{
                                                tableContainerSx: {
                                                    marginLeft: "-20px",
                                                    width: "calc(100% + 40px)",
                                                    boxShadow: "unset",
                                                    borderRadius: "unset",
                                                },
                                                tableHeadSx: {
                                                    "&.MuiTableHead-root .MuiTableCell-root": {
                                                        fontSize: "14px",
                                                        lineHeight: "18px",
                                                        fontWeight: 400,
                                                        color: "#000",
                                                        textTransform: "inherit",
                                                        background: "#FCFCFD",
                                                    },
                                                },
                                                tableHeaderCellSx: {
                                                    background: "#FCFCFD",

                                                    color: "red",

                                                    ".MuiTableHead-root &": {
                                                        borderTop: "1px solid #EAECF0",
                                                        borderBottom: "1px solid #EAECF0",
                                                    },
                                                },
                                                tableBodySx: {
                                                    "&.MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
                                                        borderBottom: "1px solid #EAECF0",
                                                    },
                                                    "&.MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root": {
                                                        borderBottom: "none",
                                                    },

                                                    "&.MuiTableBody-root .MuiTableCell-root": {
                                                        cursor: "pointer",
                                                    },
                                                },
                                            }}
                                            onRowClickHandler={(record) => {
                                                handleCardClick(record.id);
                                            }}
                                        />
                                    ) : (
                                        <Grid container spacing={3} alignItems="stretch">
                                            {getRecords().map((record) => (
                                                <Grid
                                                    item
                                                    key={record.id}
                                                    xs={12}
                                                    sm={6}
                                                    md={4}
                                                    onClick={() => handleCardClick(record.id)}
                                                    sx={{
                                                        "@media (min-width: 1200px) and (max-width:1300px)": {
                                                            width: "50%",
                                                        },
                                                        "@media (min-width: 600px) and (max-width:650px)": {
                                                            width: "100%",
                                                        },
                                                    }}
                                                >
                                                    <EventCard event={record} type="proposal"></EventCard>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    )}
                                </>
                            )}
                        </Paper>
                    </Box>
                </>
            )}
        </>
    );

    const modifiedStatus = status === "loading" ? "" : status;
    return getPageContent(body, modifiedStatus, error);
};

export { Home };
